import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { isSwedish } from '../../constants/languages';
import { getTranslation } from '../../constants/languages';

type WcbNameContainerProps = {
  iimclient: ConfigClientType;
  displayName?: string;
  changeDisplayName: Function;
};

const Translations = {
  lang_no: 'Ditt navn',
  lang_se: 'Ditt namn',
  lang_dk: 'Dit navn',
  lang_fi: 'Sinun nimesi',
  lang_en: 'Your name'
}

const WcbNameContainer = ({ iimclient, displayName, changeDisplayName }: WcbNameContainerProps) => {
  const { segment, lang, callbackQueues } = iimclient;
  const translation = getTranslation(lang, Translations) || '';
  const showContainer = isSwedish(iimclient) && !segment && callbackQueues && callbackQueues.length;

  const handleChange = ({ target }) => changeDisplayName(target.value)
  
  return showContainer && (
    <div className="input-block wcb-name-container helpinput" id="wcb-name-container">
      <label htmlFor="wcb-name" id="wcb-name-input">
        {translation}
      </label>
      <input
        className="if input-field"
        name="wcb-name"
        type="text"
        id="wcb-name"
        aria-labelledby="wcb-name-input"
        value={displayName}
        onChange={handleChange}
      />
    </div>
  );
};

export default WcbNameContainer;
